// extracted by mini-css-extract-plugin
export default {"section":"_79ce1d31"};